import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.2rem;
`;

const Trigger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 3.2rem;
  height: 3.2rem;
  padding: 0;

  font-size: 1.8rem;
  color: ${pickColor('black')};
  background: none;
  border: 0.1rem solid transparent;
  border-radius: ${({ theme }) => theme.borderRadius.base};
  cursor: pointer;

  &:hover,
  &[aria-expanded='true'] {
    border-color: ${pickColor('black')};
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;

const Menu = styled.div`
  position: fixed;
  z-index: 1000;

  min-width: 16rem;
  padding: 0.4rem 0;
  border-radius: 0.4rem;

  background-color: ${pickColor('white')};
  box-shadow: rgba(99, 99, 99, 0.4) 0 0.4rem 1.2rem 0;
`;

const MenuItem = styled.button<{ $isDanger?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.8rem;

  width: 100%;
  padding: 0.8rem 1.6rem;

  font-size: 1.4rem;
  text-align: left;
  color: ${({ $isDanger }) => ($isDanger ? pickColor('colmarRed') : pickColor('black'))};
  background: none;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
  }
`;

export { Container, Menu, MenuItem, Trigger };
